import React, { createContext, useState, useContext } from 'react';
import translations from '../i18n/translations';

// Create a context for language management
const LanguageContext = createContext();

// Available languages - only supporting English and Chinese
const languages = [
  { code: 'en', name: 'English' },
  { code: 'zh', name: '中文' }
];

// Custom hook for easy access to language context
export const useLanguage = () => useContext(LanguageContext);

// Language provider component
export const LanguageProvider = ({ children }) => {
  // 默认为中文，忽略本地存储中可能的语言设置
  // 这确保了每次应用加载时总是以中文版本开始
  const [language, setLanguage] = useState('zh');

  // 只在用户明确更改语言时更新本地存储
  const changeLanguage = (langCode) => {
    if (Object.keys(translations).includes(langCode)) {
      setLanguage(langCode);
      // 只有当用户主动选择语言时才存储到localStorage
      localStorage.setItem('language', langCode);
    }
  };

  // Translation function with special handling for banner text
  const t = (key) => {
    // Special case: For banner text keys, always return English version regardless of selected language
    if (key === 'hero_title' || key === 'hero_subtitle_middle' || key === 'hero_subtitle') {
      return translations['en'][key];
    }
    
    // For all other keys, use the selected language
    const translationObj = translations[language];
    return translationObj && translationObj[key] ? translationObj[key] : key;
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t, languages }}>
      {children}
    </LanguageContext.Provider>
  );
}; 